(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3022,4194,2385],{

/***/ 27476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ FaCheck; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaCheck(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 68840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ FiCalendar; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FiCalendar(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "4",
        "width": "18",
        "height": "18",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "2",
        "x2": "16",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "2",
        "x2": "8",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "10",
        "x2": "21",
        "y2": "10"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 90846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ GrNext; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function GrNext(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "fill": "none",
        "stroke": "#000",
        "strokeWidth": "2",
        "points": "7 2 17 12 7 22"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 80703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ GrPrevious; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function GrPrevious(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "fill": "none",
        "stroke": "#000",
        "strokeWidth": "2",
        "points": "7 2 17 12 7 22",
        "transform": "matrix(-1 0 0 1 24 0)"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 38626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var common_functions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98989);
/* harmony import */ var components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68840);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27597);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);





/** ========== */





var PostItem = function PostItem(_ref) {
  var _post$categories;

  var post = _ref.post,
      layout = _ref.layout;
  var category = post === null || post === void 0 ? void 0 : (_post$categories = post.categories) === null || _post$categories === void 0 ? void 0 : _post$categories.nodes.filter(function (item) {
    return item.parent === null;
  });

  if (layout === "vertical") {
    var _post$featuredImage;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: "flex h-full flex-1 flex-col rounded-3xl bg-white transition-shadow duration-150 hover:shadow-[0px_0px_20px_#7c787833] xl:max-w-sm",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        image: post === null || post === void 0 ? void 0 : (_post$featuredImage = post.featuredImage) === null || _post$featuredImage === void 0 ? void 0 : _post$featuredImage.node,
        wrapper: {
          className: "w-full relative"
        },
        className: "aspect-[16/9] h-full w-full rounded-t-3xl object-cover"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: "flex flex-1 flex-col justify-between p-6",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            as: "h3",
            className: "text-lg font-semibold text-bbc-brand-800 line-clamp-2",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              href: post === null || post === void 0 ? void 0 : post.uri,
              children: post === null || post === void 0 ? void 0 : post.title
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: "mt-4 line-clamp-3",
            dangerouslySetInnerHTML: {
              __html: post === null || post === void 0 ? void 0 : post.excerpt
            }
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "flex flex-wrap justify-between",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: "mt-6 inline-flex items-center rounded-md bg-bbc-brand-800 px-2 py-0.5",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              src: "/assets/icons/".concat(category[0].name.toLowerCase(), ".svg"),
              alt: "icon",
              width: 16,
              height: 16
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
              className: "inline-block pl-[5px] text-sm font-medium text-white",
              children: category.length > 0 && category[0].name
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: "mt-6 inline-flex items-center",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_0__/* .FiCalendar */ .v, {
              size: 18
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
              className: "inline-block pl-2 text-sm",
              children: (0,common_functions__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p)(post === null || post === void 0 ? void 0 : post.date)
            })]
          })]
        })]
      })]
    });
  }

  if (layout === "horizontal") {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: "text-bbc-brand-700",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          as: "h3",
          className: "text-lg font-medium line-clamp-2",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            href: post === null || post === void 0 ? void 0 : post.uri,
            children: post === null || post === void 0 ? void 0 : post.title
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "mt-6 inline-flex items-center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_0__/* .FiCalendar */ .v, {
            size: 18
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
            className: "inline-block pl-2 text-sm",
            children: (0,common_functions__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p)(post === null || post === void 0 ? void 0 : post.date)
          })]
        })]
      })
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {});
};

/* harmony default export */ __webpack_exports__["Z"] = (PostItem);
PostItem.defaultProps = {
  post: {},
  layout: "vertical"
};
/** ========== */

/***/ }),

/***/ 37768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31741);
/* harmony import */ var components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69156);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


/* ========== */





var Component = function Component(_ref) {
  var data = _ref.data,
      title = _ref.title,
      description = _ref.description,
      defaultActiveKey = _ref.defaultActiveKey,
      multipleOpen = _ref.multipleOpen,
      buttonClass = _ref.buttonClass,
      panelClass = _ref.panelClass;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      text: title || "Frequently Asked Questions",
      className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800  lg:text-bbc-40px "
    }), description ? description.trim().length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
      className: "mb-6 text-center lg:mb-10",
      children: description
    }) :
    /*#__PURE__*/
    // <p className="text-center mb-6 lg:mb-10">
    //   Know more about our nominee service with commonly asked questions.
    // </p>
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      data: data,
      haveTabs: !Array.isArray(data),
      defaultActiveKey: defaultActiveKey || false,
      multipleOpen: multipleOpen || false,
      buttonClass: buttonClass,
      panelClass: panelClass
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);

/***/ }),

/***/ 78354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src433047331_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src433047331_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91164);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["title", "subTitle", "data", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src433047331_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/** ========== */




var Component = function Component(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      data = _ref.data,
      children = _ref.children,
      props = (0,_codebuild_output_src433047331_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "row gap-y-6 lg:justify-end lg:gap-y-10",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: "col-12 lg:col-4",
          children: children ? children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            as: "h2",
            className: "text-center font-semibold lg:text-left",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              className: "block text-bbc-40px text-bbc-brand-800",
              children: title
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              className: "mt-4 block text-2xl  leading-9 ".concat(subTitle && subTitle === "in 4 easy steps" ? "text-bbc-brand-600" : "text-bbc-brand-800"),
              children: subTitle
            })]
          })
        }), (data === null || data === void 0 ? void 0 : data.length) > 0 && data.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
            className: "col-12 lg:col-4",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                className: "mb-6 flex items-center justify-center rounded-full bg-white text-lg font-semibold text-bbc-yellow-500",
                style: {
                  width: "58px",
                  height: "58px",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)"
                },
                children: index + 1
              }), (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                as: "h3",
                className: "mb-4 text-2xl font-medium text-bbc-brand-700 lg:mb-6 lg:font-semibold",
                children: item.title
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
                className: "leading-bbc-26 text-bbc-gray",
                dangerouslySetInnerHTML: {
                  __html: item.content
                }
              })]
            })
          }, index);
        })]
      })
    })
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);
Component.defaultProps = {
  data: []
};
/** ========== */

/***/ }),

/***/ 82385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _codebuild_output_src433047331_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src433047331_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91164);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88116);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98352);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var components_atoms_Icon_gr_GrNext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90846);
/* harmony import */ var components_atoms_Icon_gr_GrPrevious__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80703);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31741);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31857);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);


var _excluded = ["thetitle", "navResponsiveClass", "paginationResponsiveClass", "children", "description"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src433047331_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var swiper = {
  preloadImages: false,
  lazy: true,
  loop: false,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
    pauseOnMouseEnter: true
  },
  pagination: {
    el: ".bbc-slide-pagination",
    clickable: true,
    bulletClass: "bbc-pagination-bullet"
  },
  navigation: {
    nextEl: ".bbc-button-next",
    prevEl: ".bbc-button-prev"
  },
  slidesPerView: 3,
  spaceBetween: 30,
  // Responsive breakpoints
  breakpoints: {
    1280: {
      slidesPerView: 3,
      spaceBetween: 30,
      slidesPerGroup: 3
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 30,
      slidesPerGroup: 2
    },
    768: {
      slidesPerView: 1,
      spaceBetween: 40,
      slidesPerGroup: 1
    },
    320: {
      slidesPerView: 1,
      spaceBetween: 40,
      slidesPerGroup: 1,
      navigation: true
    }
  }
};
/** ========== */

var PostSlider = function PostSlider(_ref) {
  var thetitle = _ref.thetitle,
      navResponsiveClass = _ref.navResponsiveClass,
      paginationResponsiveClass = _ref.paginationResponsiveClass,
      children = _ref.children,
      description = _ref.description,
      props = (0,_codebuild_output_src433047331_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
    className: "relative",
    children: [thetitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      className: "title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800",
      children: thetitle
    }), description && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
      className: "mb-6 text-center lg:mb-10",
      children: description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, _objectSpread(_objectSpread(_objectSpread({
      modules: [swiper__WEBPACK_IMPORTED_MODULE_1__/* .Autoplay */ .pt, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Navigation */ .W_, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Pagination */ .tl],
      className: " !p-4"
    }, swiper), props), {}, {
      children: [children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: "bbc-slide-pagination relative  block pt-6 text-center ".concat(props.showPaginationClass || " lg:invisible", " ").concat(paginationResponsiveClass)
      })]
    })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
      className: "absolute top-1/2 left-1/2 hidden w-full -translate-x-1/2 -translate-y-1/2 lg:flex ".concat(navResponsiveClass),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: "bbc-button-prev ".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btn), "  ").concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btnPrev), " "),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_Icon_gr_GrPrevious__WEBPACK_IMPORTED_MODULE_7__/* .GrPrevious */ .U, {
          size: 18,
          className: "text-red-400"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: "bbc-button-next ".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btn), "  ").concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btnNext), " "),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_Icon_gr_GrNext__WEBPACK_IMPORTED_MODULE_6__/* .GrNext */ .U, {
          size: 18,
          className: "text-red-400"
        })
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (PostSlider);
PostSlider.defaultProps = {
  thetitle: null
};
/** ========== */

/***/ }),

/***/ 95183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src433047331_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src433047331_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src433047331_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src433047331_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27597);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);







/** ========== */




var RequiredDocument = function RequiredDocument(_ref) {
  var _data$content;

  var title = _ref.title,
      data = _ref.data,
      sectionClassName = _ref.sectionClassName,
      backgroundImage = _ref.backgroundImage;
  var checkBtnRight = data.button_image && Object.keys(data.button_image).length > 0;

  var renderButton = function renderButton() {
    var button = data.button;

    if (button) {
      if (button.type === "contact-us") {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "mt-6 text-center lg:text-left",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            href: button.link,
            className: "inline-block rounded-[50px] px-6 py-2 text-white transition-all hover:bg-bbc-brand-600 ".concat(button.noBackground ? "border border-white font-medium hover:border-bbc-brand-600" : "bg-bbc-primary font-semibold"),
            children: button.text
          })
        });
      }

      if (button.type === "talk-to") {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "mt-6",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            as: "button",
            onClick: /*#__PURE__*/(0,_codebuild_output_src433047331_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src433047331_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
              return _codebuild_output_src433047331_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      _context.next = 3;
                      return Tawk_API.toggle();

                    case 3:
                      _context.next = 8;
                      break;

                    case 5:
                      _context.prev = 5;
                      _context.t0 = _context["catch"](0);
                      console.error();

                    case 8:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[0, 5]]);
            })),
            children: button.text
          })
        });
      }

      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "mt-6 text-center lg:text-left",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
          href: button.link,
          className: "inline-block rounded-[50px] px-6 py-2 text-white transition-all hover:bg-bbc-brand-600 ".concat(button.noBackground ? "border border-white font-medium hover:border-bbc-brand-600" : "bg-bbc-primary font-semibold"),
          children: button.text
        })
      });
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    className: "relative ".concat(sectionClassName ? sectionClassName : "bg-bbc-brand-800 py-[50px]"),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "container relative z-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: "row",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "".concat(checkBtnRight ? "lg:col-8" : "lg:col-12"),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            as: "h2",
            text: title,
            className: "mb-6 text-center text-bbc-30px font-semibold capitalize text-white lg:text-left lg:text-bbc-40px"
          }), (data === null || data === void 0 ? void 0 : (_data$content = data.content) === null || _data$content === void 0 ? void 0 : _data$content.length) > 0 && data.content.map(function (item, index) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
              children: [item.title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                className: "mb-2 text-white ",
                dangerouslySetInnerHTML: {
                  __html: item.title
                }
              }), item.listContent && item.listContent.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("ul", {
                className: "lg:mb-2",
                children: item.listContent.map(function (element, i) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("li", {
                    className: "   relative mb-2 pl-[22px] text-white before:absolute before:top-2.5 before:left-[5px] before:inline-block before:h-1.5 before:w-1.5 before:rounded-full before:bg-bbc-secondary-100 before:content-['']",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                      dangerouslySetInnerHTML: {
                        __html: element.text
                      }
                    }), element.content && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("ul", {
                      children: element.content.map(function (element, index) {
                        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
                          className: "relative mb-2 pl-[22px] text-white  before:absolute before:top-2.5 before:left-[5px] before:inline-block before:h-1 before:w-1 before:rounded-full before:bg-white before:content-['']",
                          children: element
                        }, index);
                      })
                    })]
                  }, i);
                })
              })]
            }, index);
          }), (data === null || data === void 0 ? void 0 : data.note) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "m-0 text-white",
            dangerouslySetInnerHTML: {
              __html: data.note
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "text-center lg:text-left",
            children: renderButton()
          })]
        }), checkBtnRight && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "lg:col-4",
          children: data.button_image.type && data.button_image.type === "post" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
            href: data.button_image.uri,
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: data.button_image.src,
              alt: data.button_image.alt,
              width: data.button_image.width || 350,
              height: data.button_image.height || 350,
              className: "transition-all duration-200 hover:scale-105",
              wrapper: {
                className: "mt-6 lg-mt:0 w-full h-full z-0 flex justify-center items-center"
              }
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            href: data.button_image.uri,
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: data.button_image.src,
              alt: data.button_image.alt,
              width: 350,
              height: 350,
              className: "transition-all duration-200 hover:scale-105",
              wrapper: {
                className: "mt-6 lg-mt:0 w-full h-full z-0 flex justify-center items-center"
              }
            })
          })
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      src: backgroundImage,
      width: 1920,
      height: 737,
      className: "h-full w-full",
      wrapper: {
        className: "absolute top-0 left-0 w-full h-full z-0"
      }
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (RequiredDocument);
RequiredDocument.defaultProps = {
  title: "",
  data: {},
  sectionClassName: ""
};
/** ========== */

/***/ }),

/***/ 25637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


/** ========== */





var WhyChooseUs = function WhyChooseUs(_ref) {
  var title = _ref.title,
      data = _ref.data,
      sectionClassName = _ref.sectionClassName,
      note = _ref.note,
      children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("section", {
    className: sectionClassName,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        children: [note && note.length > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            as: "h2",
            text: title,
            className: "title-h2 mb-4 text-center text-white lg:mb-6"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
            className: "mb-10 text-center text-white",
            dangerouslySetInnerHTML: {
              __html: note
            }
          })]
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            as: "h2",
            text: title,
            className: "title-h2 mb-4 text-center text-white lg:mb-10"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: "row justify-center gap-y-6 lg:gap-y-10",
          children: data.length > 0 && data.map(function (item, index) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
              className: "col-12 ".concat(data.length === 4 ? "lg:col-3" : "lg:col-4"),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                className: "text-center",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
                  src: item.icon.src,
                  alt: item.icon.altText,
                  width: 48,
                  height: 48,
                  wrapper: {
                    className: "flex items-center justify-center bg-white rounded-[26px] h-20 w-20  mx-auto"
                  }
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                  className: "flex justify-center",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    as: "h3",
                    text: item.title,
                    className: "mt-6 w-5/6 text-lg font-semibold normal-case text-white"
                  })
                }), (item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
                  className: "mt-3 !normal-case text-white",
                  children: item.description
                })]
              })
            }, index);
          })
        })]
      })
    }), children]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (WhyChooseUs);
WhyChooseUs.defaultProps = {
  title: "",
  data: [],
  sectionClassName: ""
};
/** ========== */

/***/ }),

/***/ 71886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 25 modules
var Layout = __webpack_require__(65383);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(98352);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaCheck.js
var FaCheck = __webpack_require__(27476);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/PostItem/index.js
var PostItem = __webpack_require__(38626);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/Faqs/index.js
var Faqs = __webpack_require__(37768);
// EXTERNAL MODULE: ./components/organisms/HowItWorks/index.js
var HowItWorks = __webpack_require__(78354);
// EXTERNAL MODULE: ./components/organisms/PostSlider/index.js
var PostSlider = __webpack_require__(82385);
// EXTERNAL MODULE: ./components/organisms/RequiredDocument/index.js
var RequiredDocument = __webpack_require__(95183);
// EXTERNAL MODULE: ./components/organisms/WhyChooseUs/index.js
var WhyChooseUs = __webpack_require__(25637);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/offshore/accounting-and-auditing/index.js















var Component = function Component(_ref) {
  var _data$banner;

  var posts = _ref.posts,
      data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
        minHeightBanner: "banner-min-h-569",
        title: "Accounting, Auditing & Tax Filing",
        description: "Capitalizing our digital solutions and seasoned CPA team to untangle your complexities of annual accounting tasks",
        bgColor: "bg-bbc-gradient-service",
        breadcrumbs: data === null || data === void 0 ? void 0 : (_data$banner = data.banner) === null || _data$banner === void 0 ? void 0 : _data$banner.breadcrumbs,
        titleProps: {
          textColor: "banner-title-gradient-color"
        },
        leftClassName: "lg:col-6",
        rightClassName: "lg:col-6 xl:pl-16",
        rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: "/assets/images/common/accounting-auditing-banner.png",
          width: 622,
          height: 400,
          alt: "accounting and auditing services",
          className: "h-full w-full",
          wrapper: {
            className: "bbc-banner-image-country pb-10 lg:pb-0 banner-lg-max-w-500"
          },
          priority: true
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            text: "Accounting & Auditing",
            className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800 lg:mb-10 lg:text-bbc-40px"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-6 leading-bbc-26 lg:mb-4",
            children: "We can help you prepare and maintain accounting records to stay compliant with local regulations. Our local qualified accountants can also assist to prepare management reports with a review on a predetermined frequency to support your decision making process. Our specialized accounting system can work effectively to help you remove the needs for an in-house accounting department which is sometimes cost-ineffective to set up and maintain."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-6 leading-bbc-26 lg:mb-4",
            children: "Our solutions include:"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "row justify-center",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              className: "col-12 leading-bbc-26 lg:col-10",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                className: "relative",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                  className: "absolute top-1.5 left-0 text-bbc-brand-500",
                  size: 12
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "inline-block pl-7",
                  children: "Maintaining accounting records, including cash books, general ledgers, fixed assets, accounts receivables, and payable."
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                className: "relative mt-3",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                  className: "absolute top-1.5 left-0 text-bbc-brand-500",
                  size: 12
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "inline-block pl-7",
                  children: "Preparing monthly, quarterly and yearly management accounts, cash flow statements for management purposes."
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                className: "relative mt-3",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                  className: "absolute top-1.5 left-0 text-bbc-brand-500",
                  size: 12
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "inline-block pl-7",
                  children: "Preparing annual financial statements."
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                className: "relative mt-3",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                  className: "absolute top-1.5 left-0 text-bbc-brand-500",
                  size: 12
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "inline-block pl-7",
                  children: "Attending to the auditors during review of the company\u2019s financial records."
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                className: "relative mt-3",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                  className: "absolute top-1.5 left-0 text-bbc-brand-500",
                  size: 12
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "inline-block pl-7",
                  children: "Administering the payroll process, including calculating and crediting of the net remuneration to individual employee\u2019s bank account."
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                className: "relative mt-3",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                  className: "absolute top-1.5 left-0 text-bbc-brand-500",
                  size: 12
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "inline-block pl-7",
                  children: "Setting up a mandatory provident fund scheme."
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                className: "relative mt-3",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                  className: "absolute top-1.5 left-0 text-bbc-brand-500",
                  size: 12
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "inline-block pl-7",
                  children: "Arranging for retiring member benefits to be transferred into their new employer or into a preserved account."
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                className: "relative mt-3",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                  className: "absolute top-1.5 left-0 text-bbc-brand-500",
                  size: 12
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "inline-block pl-7",
                  children: "Completing the filing of employment with the local authorities."
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                className: "relative mt-3",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                  className: "absolute top-1.5 left-0 text-bbc-brand-500",
                  size: 12
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "inline-block pl-7",
                  children: "Application and renewal of employment visa."
                })]
              })]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mt-6 lg:mt-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            text: "Tax Compliance Services",
            className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800 lg:mb-10 lg:text-bbc-40px"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-6 leading-bbc-26 lg:mb-4",
            children: "The complex and constantly changing tax laws across many countries make the task of remaining compliant become more difficult for business owners, especially with startups and small companies. This leads to an obvious trend for outsourcing these functionalities to 3rd parties with specialized capacities to handle these compliance requirements."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-6 leading-bbc-26 lg:mb-4",
            children: "BBCIncorp can assist you to manage tax obligations with tailored solutions as follows:"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "row justify-center",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              className: "col-12 leading-bbc-26 lg:col-10",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                className: "relative",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                  className: "absolute top-1.5 left-0 text-bbc-brand-500",
                  size: 12
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "inline-block pl-7",
                  children: "Tax preparation including computing and filing appropriate tax returns to local authorities."
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                className: "relative mt-3",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                  className: "absolute top-1.5 left-0 text-bbc-brand-500",
                  size: 12
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "inline-block pl-7",
                  children: "Review tax assessments and notify you of any necessary tax payments."
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                className: "relative mt-3",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                  className: "absolute top-1.5 left-0 text-bbc-brand-500",
                  size: 12
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "inline-block pl-7",
                  children: "Assist in handling tax authority queries, tax field audits and investigation."
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                className: "relative mt-3",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                  className: "absolute top-1.5 left-0 text-bbc-brand-500",
                  size: 12
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "inline-block pl-7",
                  children: "Other local tax compliance requirements."
                })]
              })]
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(WhyChooseUs/* default */.Z, {
      title: "What makes us your good fit",
      sectionClassName: "bg-bbc-gradient-2 py-10 lg:py-20",
      data: data === null || data === void 0 ? void 0 : data.dataWhyMakeUs
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HowItWorks/* default */.Z, {
      data: data === null || data === void 0 ? void 0 : data.dataHowItWork,
      className: "mb-10 lg:mb-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Title/* default */.Z, {
        className: "text-center font-semibold lg:text-left",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: "text-3xl text-bbc-brand-800 lg:block lg:text-bbc-40px",
          children: ["How", " "]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "mt-4 text-3xl text-bbc-brand-800 lg:block lg:leading-[44px] lg:text-bbc-brand-700",
          children: "It Works ?"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(RequiredDocument/* default */.Z, {
      sectionClassName: "mb-10 lg:mb-20 pt-14 pb-20",
      backgroundImage: "/assets/images/common/required-documents.png",
      title: "Accounting required documents",
      data: data === null || data === void 0 ? void 0 : data.dataRequiredDocuments
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "lg:col-10 lg:mx-auto",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs/* default */.Z, {
            data: data === null || data === void 0 ? void 0 : data.dataFaqs
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(PostSlider["default"], {
          thetitle: "Industry News & Insights",
          children: posts.length > 0 && posts.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(PostItem/* default */.Z, {
                post: item
              })
            }, index);
          })
        })
      })
    })]
  });
};

/* harmony default export */ var accounting_and_auditing = (Component);
;// CONCATENATED MODULE: ./pages/offshore/accounting-and-auditing/data.json
var data_namespaceObject = JSON.parse('{"banner":{"breadcrumbs":[{"title":"Home","uri":"/"},{"title":"Accounting, Auditing & Tax Filing"}]},"dataWhyMakeUs":[{"icon":{"src":"/assets/icons/user-headset.svg","altText":"user-headset"},"title":"Local qualified experts","description":"Our team comprises local experts with relevant qualifications and years of hands-on experience in varied industries"},{"icon":{"src":"/assets/icons/sliders-h.svg","altText":"sliders-h"},"title":"Flexible solutions","description":"We offer multiple packages that easily comfort needs of businesses ranging from startups to small and medium companies"},{"icon":{"src":"/assets/icons/clock.svg","altText":"clock"},"title":"Accurate and timely reports","description":"You can definitely rely on our management reports for monitoring your operation as we use strict framework and automation for producing such reports"},{"icon":{"src":"/assets/icons/users.svg","altText":"users"},"title":"Excellent communication","description":"No worry of jargon anymore. We only use plain English to communicate with our clients to help them make better-informed decisions"},{"icon":{"src":"/assets/icons/coding.svg","altText":"coding"},"title":"Seamless technical integration","description":"Whatever accounting software you use i.e. Xero, Quickbooks or local mandated ones, we can easily adapt to meet your requirements"}],"dataHowItWork":[{"content":"Acquire your expectations and references along with offering several service packages tailored to your needs for selection."},{"content":"Set up an internal system with roles and accounting procedures clearly set out. We will also discuss an effective workflow for exchanging and sharing information."},{"content":"Daily transaction records being processed and listed in the accounting system on a pre-specified frequency. All other supporting documents during the ordinary course of business will be maintained."},{"content":"Closing books and compiling financial statements for a predetermined period. Finalized accounts being delivered to you for review and approval."},{"content":"Business review and analysis: At the end of each accounting period, we will talk with you about internal framework analysis and business management reports with a plan for upcoming improvements."}],"dataRequiredDocuments":{"button":{"text":"Talk To Our Expert","type":"talk-to","link":"/contact-us"},"content":[{"listContent":[{"text":"Company bank statements for the accounting reference period"},{"text":"Sales orders/invoices"},{"text":"List of customer’s deposits and pre-payments outstanding"},{"text":"Purchase invoices from suppliers, both paid and unpaid"},{"text":"Cash Expense receipts"},{"text":"Inventory listing"},{"text":"Documents pertaining to purchase, major repair and sales of fixed assets"},{"text":"Detailed payroll information"},{"text":"Any other related documents i.e. bank loans, lease agreements, insurance,..."}]}]},"dataFaqs":[{"name":"What is your pricing of accounting & auditing service?","content":"<p>Our service charges are based on volume and complexity of your transactions. We offer multiple service pricing tiers which can easily adapt to various business purposes and sizes.</p>"},{"name":"What software do you use?","content":"<p>We currently use Xero for accounting purpose. But do not worry, our local accounting team can undoubtedly handle if you want to use other ones.</p>"},{"name":"How do I ensure that my data are totally secured?","content":"<p>You can rest assured that your data will be safe with us. We reinforce security of clients&quot; data based on three pillars:</p><ul><li>We have enforced data security policy in place to govern activities of internal departments and staffs involving in dealing with data and information.</li><li>Secured data servers with restricted access and frequent monitoring on safety of information.</li><li>Public privacy policy to our clients and contractual commitment by Non-disclosure agreement.</li></ul>"},{"name":"What countries do you offer your service in?","content":"<p>At this time, we provide accounting & auditing services in Hong Kong, Singapore and UK.</p>"},{"name":"What methods can I use to submit my data?","content":"<p>We are flexible so you can freely choose your preferred methods. Below are some suggestions you might consider:</p><ul><li>Send to us via email.</li><li>Get access to documents through cloud storage.</li><li>Remote access to your internal system.</li><li>Access through web-based accounting software.</li></ul>"},{"name":"Can I do bookkeeping myself for my company?","content":"<p>Yes, you can definitely do accounting yourself. But smart business owners choose to outsource to accounting professionals who can do it in a much more efficient way, so they can have more time to focus on their core business.</p>"}]}');
;// CONCATENATED MODULE: ./pages/offshore/accounting-and-auditing/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    locationRouter: "offshore",
    page: data === null || data === void 0 ? void 0 : data.page,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(accounting_and_auditing, {
      data: data_namespaceObject,
      posts: data === null || data === void 0 ? void 0 : data.posts
    })
  });
}

/***/ }),

/***/ 36477:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/accounting-and-auditing",
      function () {
        return __webpack_require__(71886);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31857:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btn":"Index_btn___obRs","btnPrev":"Index_btnPrev__kxfmc","btnNext":"Index_btnNext__V4iBC"};

/***/ }),

/***/ 92:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 68770:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 30933:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 27884:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;
exports["default"] = JSXStyle;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _stylesheetRegistry = __webpack_require__(28122);

var _hash = __webpack_require__(39035);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = _react["default"].useInsertionEffect || _react["default"].useLayoutEffect;

function JSXStyle(props) {
  var registry = (0, _stylesheetRegistry.useStyleRegistry)(); // If `registry` does not exist, we do nothing here.

  if (!registry) {
    return null;
  }

  if (typeof window === 'undefined') {
    registry.add(props);
    return null;
  }

  useInsertionEffect(function () {
    registry.add(props);
    return function () {
      registry.remove(props);
    }; // props.children can be string[], will be striped since id is identical
  }, [props.id, String(props.dynamic)]);
  return null;
}

JSXStyle.dynamic = function (info) {
  return info.map(function (tagInfo) {
    var baseId = tagInfo[0];
    var props = tagInfo[1];
    return (0, _hash.computeId)(baseId, props);
  }).join(' ');
};

/***/ }),

/***/ 65988:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(27884)


/***/ }),

/***/ 30266:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3105,8352,4090,5383,7447,9156,9774,2888,179], function() { return __webpack_exec__(36477); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);